import { render, staticRenderFns } from "./WebServices.vue?vue&type=template&id=0d55690c&scoped=true"
import script from "./WebServices.vue?vue&type=script&lang=js"
export * from "./WebServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d55690c",
  null
  
)

export default component.exports